var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDripEmptyRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3594 1.07812C12.5625 8.48438 17.25 10.4531 17.25 15.6562C17.25 20.2969 13.5469 24 9 24C4.40625 24 0.75 20.2969 0.75 15.6562C0.75 10.4531 5.4375 8.4375 7.59375 1.07812C7.82812 0.375 8.39062 0 8.95312 0C9.5625 0 10.1719 0.375 10.3594 1.07812ZM9 21.75C12.2812 21.75 15 19.0312 15 15.6562C15 13.6406 14.0156 12.2344 12.5625 10.1719C11.4375 8.53125 10.0781 6.60938 9 3.9375C7.92188 6.60938 6.5625 8.53125 5.4375 10.1719C3.9375 12.2344 3 13.6406 3 15.6562C3 19.0312 5.67188 21.75 9 21.75ZM9.75 18.75C10.125 18.75 10.5 19.0781 10.5 19.5C10.5 19.875 10.125 20.25 9.75 20.25C6.84375 20.25 4.5 17.9062 4.5 15C4.5 14.625 4.82812 14.25 5.25 14.25C5.625 14.25 6 14.625 6 15C6 17.1094 7.64062 18.75 9.75 18.75Z",
    fill: "#FA5C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDripEmptyRed);
export default __webpack_public_path__ + "static/media/drip-empty-red.7b1d76040e0fdcd539037ecc39102048.svg";
export { ForwardRef as ReactComponent };